import { render, staticRenderFns } from "./RolPermisosDetails.vue?vue&type=template&id=776f7172&scoped=true"
import script from "./RolPermisosDetails.vue?vue&type=script&lang=js"
export * from "./RolPermisosDetails.vue?vue&type=script&lang=js"
import style0 from "./RolPermisosDetails.vue?vue&type=style&index=0&id=776f7172&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776f7172",
  null
  
)

export default component.exports